import { createAction } from 'redux-actions';

export const setMunicipiosAction = createAction(
  'EMISION__CATALOGOS__SET_MUNICIPIOS',
);

export const setColoniasAction = createAction('EMISION__CATALOGOS__SET_COLONIAS');

export const setLoadingMunicipiosAction = createAction(
  'EMISION_CATALOGOS_SET_LOADING_MUINICIPIOS',
);

export const setLoadingColoniasAction = createAction(
  'EMISION_CATALOGOS_SET_LOADING_COLONIAS',
);
